var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var DeliveryMethodsList = /** @class */ (function (_super) {
    __extends(DeliveryMethodsList, _super);
    function DeliveryMethodsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridHeaders = [
            { name: 'Име', key: 'bg_name', filter: false, sort: false },
            { name: 'Цена', key: 'price', filter: false, sort: false },
            { name: 'Активен', key: 'active', formatter: 'boolean', filter: false, sort: false },
            { name: 'Тип', key: 'delivery_type', formatter: 'deliveryMethod', filter: false, sort: false },
            { name: 'Позиция', key: 'position', filter: false, sort: false }
        ];
        _this.editProduct = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editDeliveryMethod.path.replace(':id', selectedId));
            }
        };
        return _this;
    }
    DeliveryMethodsList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: 50, rows: 10, editAction: this.editProduct }));
    };
    return DeliveryMethodsList;
}(React.Component));
// @ts-ignore
export default withRouter(DeliveryMethodsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/DeliveryMethods/DeliveryMethodsList/DeliveryMethodsList.tsx
// module id = 344
// module chunks = 0